export const ANALYTICS_EVENTS = {
  // Launch
  FIRST_LAUNCH: 'First launch',
  SESSION_START: 'Session start',

  // Network
  CHANGE_NETWORK: 'Change Network',

  // Burger
  CHANGE_THEME: 'Change Theme',
  CHANGE_LOCALE: 'Change Language',

  // Onboarding
  ACCEPT_COOKIES: 'Accept Cookies',
  REJECT_COOKIES: 'Reject Cookies',

  // Wallet
  OPEN_CONNECT_WALLET_MODAL: 'Open Connect Wallet Modal',
  CONNECT_WALLET: 'Connect Wallet',
  CONNECT_WALLET_ERROR: 'Connect Wallet Error',
  CONNECT_WALLET_INSTALL_EXTENSION: 'Connect Wallet Install Extension',
  OPEN_WALLET_MODAL: 'Open Wallet Modal',
  DISCONNECT_WALLET: 'Disconnect Wallet',
  POLLING_DISCONNECT_WALLET: 'Polling Disconnect Wallet',

  // Swap
  SWAP_CLICK_SWITCH: 'Swap Click Switch',
  SWAP_CLICK_CHANGE_POOL: 'Swap Click Change Pool',
  SWAP_CHANGE_POOL: 'Swap Change Pool',
  SWAP_SUBMIT: 'Swap Submit',
  SWAP_CONFIRM: 'Swap Confirm',
  SWAP_CLOSE_CONFIRM: 'Swap Close Confirm',
  SWAP_SIGNED: 'Swap Signed',
  SWAP_CONFIRM_ERROR: 'Swap Confirm Error',
  SWAP_SIGNED_ERROR: 'Swap Signed Error',

  // Deposit
  DEPOSIT_SUBMIT: 'Deposit Submit',
  DEPOSIT_CONFIRM: 'Deposit Confirm',
  DEPOSIT_SIGNED: 'Deposit Signed',
  DEPOSIT_SIGNED_ERROR: 'Deposit Signed Error',
  DEPOSIT_SELECT_X: 'Deposit Select X',
  DEPOSIT_SELECT_Y: 'Deposit Select Y',
  DEPOSIT_INPUT_X: 'Deposit Input in X',
  DEPOSIT_INPUT_Y: 'Deposit Input in Y',
  DEPOSIT_CLICK_25: 'Deposit Click 25',
  DEPOSIT_CLICK_50: 'Deposit Click 50',
  DEPOSIT_CLICK_75: 'Deposit Click 75',
  DEPOSIT_CLICK_100: 'Deposit Click 100',
  DEPOSIT_CLICK_CREATE_POOL: 'Deposit Click Create Pool',
  DEPOSIT_CLICK_POOL_SELECT: 'Deposit Click Pool Select',
  DEPOSIT_SELECT_POOL: 'Deposit Select Pool',

  // Redeem
  REDEEM_SUBMIT: 'Redeem Submit',
  REDEEM_CONFIRM: 'Redeem Confirm',
  REDEEM_SIGNED: 'Redeem Signed',
  REDEEM_SIGNED_ERROR: 'Redeem Signed Error',
  REDEEM_CLOSE_CONFIRM: 'Redeem close confirm',

  // Catalyst 9 events
  CATALYST_CLOSE: 'Catalyst 9 close',
  CATALYST_CTA: 'Catalyst 9 click CTA',

  //Liquidity
  LIQUIDITY_ADD: 'Liquidity Select > Add Liquidtity',
  LIQUIDITY_CREATE_POOL: 'Liquidity Select > Create Pool',
};
